<template>
    <div  :class="['padding_bottom_64',{'bodyfixed':ismodalshow,'bodyauto':!ismodalshow}]" ref='report'>
        <div >
            <div class="banner"  :style="'backgroundImage:url('+reportdata.detailBannerPc+')'"></div>
            <div class="inner display_flex justify-content_flex-justify padding-32">
                <div class="reportcontian">
                    <div class="report_title">{{reportdata.title}}</div>
                    <div class="padding_16"><span class="report_time">{{$t('rankindex.chupinfang')}} · {{$t('rankindex.report_fishqc')}} · {{formatTimefun(reportdata.publishTime)}}</span>
                        <!-- <span class="report_collect">收藏</span> -->
                       <!--  <div  :class="['collect_btn_top',{'active':reportdata.favor}]" @click="collect()">{{$t('product.collectrank')}}</div> -->
                    </div>
                    <div class="report_desc" v-html="reportdata.summary"></div>
                    <div class="title_box">
                        <div class="report_subtitle" ref="speaker">{{$t('rankindex.report_speaker')}}</div>
                        <div class="title_line"></div>
                    </div>
                    <div class="display_flex justify-content_flex-justify margin_top_26 margin_bottom_32">
                        <div class="display_flex justify-content_flex-justify flex-direction_column">
                            <div class="speaker">{{reportdata.expertDescription}}</div>
                            <div class="speaker_bottom">
                                <div class="title">{{reportdata.expertName}}</div>
                                <div>{{$t('rankindex.report_expertName')}}</div>
                            </div>
                        </div>
                        <div>
                            <video :src="reportdata.detailVideo" :poster="reportdata.videoCover" controls="controls" style="width:588px;height:384px;"></video>
                        </div>
                    </div>
                    <div class="title_box">
                        <div class="report_subtitle" ref="safe_test_result">{{$t('rankindex.pc_desc1')}}</div>
                        <div class="title_line"></div>
                    </div>
                    <!-- <div class="testresult">产品安全性测试结果</div> -->
                    <div class="result1" style="padding-top:18px;padding-left:0">{{$t('rankindex.report_result',[totalSample,reportdata.productCategory,reportdata.totalGreenProduct,reportdata.totalYellowProduct,reportdata.totalRedProduct,reportdata.banIngProductNum,reportdata.productCategory])}}</div>
                    <div class="display_flex  align-items_center">
                        <div class="display_flex flex-wrap_wrap padding_top_28">
                            <div class="padding_right64">
                                <div class="resultNum">{{totalSample}}</div>
                                <div class="resultdesc">{{$t('rankindex.report_test_num')}}</div>
                            </div>
                           <!--  <div>
                                <div class="resultNum">{{reportdata.totalBrand}}</div>
                                <div class="resultdesc">样本品牌数量</div>
                            </div> -->
                        </div>
                        <div class="display_flex justify-content_flex-justify padding_top_20">
                            <div class="">
                                <div class="position_relative">
                                    <img src="http://p1.fishqc.net/FjFwYIpjv8nV8yrfUg8O1ByMm-EF" class="vertical-middle fishimg">
                                    <span class="fishqcround green vertical-middle">{{reportdata.totalGreenProduct}}</span>
                                </div>
                                <div class="fishdesc">{{$t('common.green_Title')}}</div>
                            </div>
                            <div class="padding_left_42">
                                <div class="position_relative">
                                    <img src="http://p1.fishqc.net/FkwJBCGNGbTokp_j7_k_YDjS7LM5" class="vertical-middle fishimg">
                                    <span class="fishqcround yellow vertical-middle">{{reportdata.totalYellowProduct}}</span>
                                </div>
                                <div class="fishdesc">{{$t('common.yellow_Title')}}</div>
                            </div>
                            <div class="padding_left_42">
                                <div class="position_relative">
                                    <img src="http://p1.fishqc.net/Fsj1cltSch3P6j5y4HuKnx8r_Y9q" class="vertical-middle fishimg">
                                    <span class="fishqcround red vertical-middle">{{reportdata.totalRedProduct}}</span>
                                </div>
                                <div class="fishdesc">{{$t('common.red_Title')}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="title_box">
                        <div class="report_subtitle" ref="data_fenxi">{{$t('rankindex.report_analysis')}}</div>
                        <div class="title_line"></div>
                    </div>
                    <div class="sub_report_title sub_report_title_padding">{{$t('rankindex.report_analysis1')}}</div>
                    <div class="sub_report_desc">{{$t('rankindex.report_analysis2')}}</div>

                    <div class="testresult"><div class="relative">{{$t('rankindex.report_analysis3')}}</div></div>
                    <div class="result1">{{$t('rankindex.report_analysis4')}}</div>
                    <div style="margin:16px 0 25px;" >
                        <div class="display_flex flex-wrap_wrap align-items_center">
                            <el-progress class="eeqprogressclass" type="circle"  :percentage="atGreenPercent" :color="greencolors" stroke-linecap="square" :stroke-width="stroke_width" :width="eeqprogresswidth" style="margin:0 60px 0 16px;" ref="eeqgreenprogress"></el-progress>
                            <el-progress type="circle" :stroke-width="stroke_width" :percentage="atYellowPercent" :color="yellowcolors" stroke-linecap="square" :width="eeqprogresswidth" style="margin:0 80px 0 0px;"></el-progress>
                            <el-progress type="circle" :stroke-width="stroke_width" :percentage="atRedPercent" :color="redcolors" stroke-linecap="square" :width="eeqprogresswidth"></el-progress>
                            <div class="padding_left_70">
                                <div class="round_desc"><div class="relative green">{{$t('rankindex.report_excellent')}}</div></div>
                                <div class="round_desc"><div class="relative yellow">{{$t('rankindex.report_pass')}}</div></div>
                                <div class="round_desc"><div class="relative red">{{$t('rankindex.report_needchange')}}</div></div>
                            </div>
                        </div>
                        <div class="display_flex flex-wrap_wrap align-items_center">
                            <div class="textalign_center display_flex flex-direction_column" style="width:160px;margin:0 60px 0 16px;">
                                <div class="green_round"></div>
                                <div class="green_round"></div>
                                <div>{{$t('rankindex.report_excellent')}} {{reportdata.atGreen}} {{$t('rankindex.Num')}}</div>
                            </div>
                            <div class="textalign_center display_flex flex-direction_column" style="width:160px;margin:0 80px 0 0px;">
                                <div class="yellow_round"></div>
                                <div class="yellow_round"></div>
                                <div>{{$t('rankindex.report_pass')}} {{reportdata.atYellow}} {{$t('rankindex.Num')}}</div>
                            </div>
                            <div class="textalign_center display_flex flex-direction_column" style="width:160px;">
                                <div class="red_round"></div>
                                <div class="red_round"></div>
                                <div>{{$t('rankindex.report_needchange')}} {{reportdata.atRed}} {{$t('rankindex.Num')}}</div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="atresult_desc">{{$t('rankindex.report_result_1',[totalSample,reportdata.productCategory,reportdata.atGreen,atGreenPercent,reportdata.atYellow,atYellowPercent,reportdata.atRed,atRedPercent])}}</div>
                    <div class="testresult"><div class="relative">{{$t('rankindex.report_result_2')}}</div></div>
                    <div class="result1">{{$t('rankindex.report_result_3')}}</div>
                    <div style="margin:16px 0 25px;" >
                        <div class="display_flex flex-wrap_wrap align-items_center">
                            <el-progress class="eeqprogressclass" type="circle"  :percentage="eeqGreenPercent" :color="greencolors" stroke-linecap="square" :stroke-width="stroke_width" :width="eeqprogresswidth" style="margin:0 60px 0 16px;" ref="eeqgreenprogress"></el-progress>
                            <el-progress type="circle" :stroke-width="stroke_width" :percentage="eeqRedPercent" :color="redcolors" stroke-linecap="square" :width="eeqprogresswidth" ></el-progress>
                            <div class="padding_left_110">
                                <div class="round_desc"><div class="relative green">{{$t('rankindex.report_man_pass')}}</div></div>
                                <div class="round_desc"><div class="relative red">{{$t('rankindex.report_man_nopass')}}</div></div>
                            </div>
                        </div>
                        <div class="display_flex flex-wrap_wrap align-items_center">
                            <div class="textalign_center display_flex flex-direction_column" style="margin:0 60px 0 16px;width:170px;">
                                <div class="green_round"></div>
                                <div class="green_round"></div>
                                <div>{{$t('rankindex.report_man_pass')}} {{reportdata.eeqGreen}} {{$t('rankindex.Num')}}</div>
                            </div>
                            <div class="textalign_center display_flex flex-direction_column" >
                                <div class="red_round"></div>
                                <div class="red_round"></div>
                                <div>{{$t('rankindex.report_man_nopass')}} {{reportdata.eeqRed}} {{$t('rankindex.Num')}}</div>
                            </div>
                        </div>
                        
                    </div>
                    
                    <div class="atresult_desc textalign_left">{{$t('rankindex.report_test_result1',[reportdata.eeqGreen,eeqGreenPercent,reportdata.eeqRed,eeqRedPercent])}}<br>{{$t('rankindex.report_test_result2',[reportdata.eeqRed])}}</div>
                    <div class="sub_report_title sub_report_title_padding">{{$t('rankindex.report_chengfen_1')}}</div>
                    <div class="sub_report_desc" v-html="reportdata.ingredientAnalysis"></div>
                    <table class="margin_top_16" v-if="reportdata.banIngListContent">
                        <tbody>
                            <tr style="background:#FAFAFA">
                                <th class="liveTestth width_120">{{$t('rankindex.report_chengfen_2')}}</th>
                                <th class="liveTestth width_120">{{$t('rankindex.report_chengfen_3')}}</th>
                                <th class="liveTestth width_120">{{$t('rankindex.report_chengfen_4')}}</th>
                                <th class="liveTestth width_430">{{$t('rankindex.report_chengfen_5')}}</th>
                            </tr>
                            <tr  v-for="item in reportdata.banIngListContent">
                                <td class="liveTesttd width_120">
                                    {{item.ingname}}
                                </td>
                                <td class="liveTesttd width_120">
                                    {{item.samplenum}}
                                </td>
                                <td class="liveTesttd width_120">
                                    {{item.function}}
                                </td>
                                <td class="liveTesttd width_430">
                                   {{item.desc}}
                                </td>
                               
                            </tr>
                        </tbody>
                    </table>
                    <div v-if="reportdata.continentsTotal !=null && reportdata.continentsTotal.content!=null">
                        <div class="sub_report_title sub_report_title_padding">{{$t('rankindex.report_area_biji')}}</div>
                        <div class="sub_report_desc">{{$t('rankindex.report_arealist',[reportdata.productCategory])}}</div>
                        <div class="padding_top_16 padding_bottom_24">
                            <div class="green_desc">{{$t('common.green_Title')}}</div>
                            <div class="yellow_desc">{{$t('common.yellow_Title')}}</div>
                            <div class="red_desc">{{$t('common.red_Title')}}</div>
                        </div>
                    </div>
                    <div v-if="reportdata.continentsTotal !=null && reportdata.continentsTotal.content!=null">
                        <div class="width_50" v-for="(item,index) in reportdata.continentsTotal.content">
                            <div class="product_detail_effecttxt">
                                <div  class="product_detail_effecttxtbg"></div>
                                <span class="effectresult">{{continents[index]}}</span>
                            </div>
                            <div class="place">
                                <div>{{continents[index]}}品牌样本共{{reportdata.continentsTotal.content[index].green + reportdata.continentsTotal.content[index].yellow + reportdata.continentsTotal.content[index].red}}个 </div>
                                <div>{{reportdata.continentsTotal.content[index].green}}个（{{keepOne(reportdata.continentsTotal.content[index].green,(reportdata.continentsTotal.content[index].green + reportdata.continentsTotal.content[index].yellow + reportdata.continentsTotal.content[index].red))}}%）为绿鱼，{{reportdata.continentsTotal.content[index].yellow}}个（{{keepOne(reportdata.continentsTotal.content[index].yellow,(reportdata.continentsTotal.content[index].green + reportdata.continentsTotal.content[index].yellow + reportdata.continentsTotal.content[index].red))}}%）为黄鱼，{{reportdata.continentsTotal.content[index].red}}个（{{keepOne(reportdata.continentsTotal.content[index].red,(reportdata.continentsTotal.content[index].green + reportdata.continentsTotal.content[index].yellow + reportdata.continentsTotal.content[index].red))}}%）为红鱼</div>
                            </div>
                            <div style="widht:100%;height:300px;background-color:#fff;margin-top:12px;margin-bottom:30px;">
                                <div ref="myChart" style="width:400px;height:300px;" ></div>
                            </div>
                        </div>
                    </div>
                    <div class="placeresult" v-if="reportdata.continentsTotal !=null && reportdata.continentsTotal.footercomment !=null && reportdata.continentsTotal.footercomment !=''">{{reportdata.continentsTotal.footercomment}}</div>
                    <div class="sub_report_title sub_report_title_padding">{{$t('rankindex.report_price_bijiao')}}</div>
                    <div class="sub_report_desc" v-html="reportdata.productPriceContentHead"></div>
                    <div class="padding_top_16 padding_left_28">
                        <div class="product_detail_effecttxt small">
                            <div  class="product_detail_effecttxtbg"></div>
                            <span class="effectresult ">{{$t('rankindex.report_price_comparison')}}</span>
                        </div>
                        <div class="position_relative">
                            <div class="price_standard padding_top_16">
                                <span>¥<span class="arr">↓</span>{{$t('rankindex.report_price_low')}}</span><span class="price_distance"></span><span class="bigger">{{reportdata.productPriceLowest}} 元/{{reportdata.productPriceUnit}}</span>
                            </div>
                            <div class="price_standard padding_top_16" >
                                <span>¥<span class="arr">↓</span>{{$t('rankindex.report_price_high')}}</span><span class="price_distance" style="width:440px;"></span><span class="bigger">{{reportdata.productPriceHighest}} 元/{{reportdata.productPriceUnit}}</span>
                            </div>
                            <div class="position_absulute">
                                <img src="http://p1.fishqc.net/FtMteFS16-KN9OysaHLEYWzgsrqn" class="vertivalalign_bottom margin_right_10">
                                <div class="inline-block vertivalalign_bottom">
                                    <div class="price_standard">{{$t('rankindex.report_price_vary')}}</div>
                                    <div class="beishu">{{mulriple}}{{$t('rankindex.bei')}}</div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="sub_report_desc padding_top_16" v-html="reportdata.productPriceContentFoot"></div>
                   
                    <div>
                        <div class="title_box">
                            <div class="report_subtitle" ref="green_ranks">{{$t('index.rankTitle')}}</div>
                            <div class="title_line"></div>
                        </div>
                        <div class="desc3">{{$t('rankindex.pc_report_result1',[reportdata.totalGreenProduct,reportdata.productCategory])}}
                        </div>
                        <div class="display_flex flex-wrap_wrap">
                            <div v-for="item in reportdata.prdList" class="rankItem display_flex" @click="toproductdetail(item)">
                                <div class="rankItem_productimg" :style="'backgroundImage:url('+item.productImage+')'">
                                </div>
                                <div class="flex_1 display_flex flex-direction_column horizontal-between">
                                    <div class="product_title">
                                        <div class="prodcutname">{{item.productName}}</div>
                                        <!-- <div>亚马逊白泥净致面膜</div> -->
                                        <div class="product_bable" v-if="item.efficacy">{{$t('product.effecy_xianzhu')}}</div>
                                    </div>
                                    <div class=" productdetail display_flex justify-content_flex-justify align-items_center">
                                        <img src="../../assets/images/greenfish.png" height="65" width="66">
                                        <div class="productitemdetail">
                                            <div class="productitemdetails ">
                                                <span class="fix-width-60">{{$t('product.size')}}</span>
                                                <span class="color">{{item.size}}</span>
                                            </div>
                                            <div class="productitemdetails ">
                                                <span class="fix-width-60">{{$t('product.price')}}</span>
                                                <span class="color">{{item.price}} {{item.currency}}</span>
                                            </div>
                                            <div class="productitemdetails ">
                                                <span class="fix-width-60">{{$t('index.address')}}</span>
                                                <span class="color">{{item.originPlace}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 真人试用 -->
                    <div class="title_box">
                        <div class="report_subtitle" ref="real_test">{{$t('rankindex.report_menutest')}}</div>
                        <div class="title_line"></div>
                    </div>
                    <div class="testresult"><div class="relative">{{$t('rankindex.test_chooseproduct')}}</div></div>
                    <div class="result1">{{reportdata.liveIntruction}}</div>
                    <div class="textalign_center padding_top_16">
                        <img :src="reportdata.liveFamilyImage" alt="" class="width_100">
                    </div>
                    <div class="testresult"><div class="relative">{{$t('rankindex.testpeoper')}}</div></div>
                    <div class="result1" v-html="reportdata.liveTestCondition"></div>
                    <div class="testresult"><div class="relative">{{$t('rankindex.teststander')}}</div></div>
                    <table class="margin_top_16" style="width:100%;"  v-if="reportdata.liveTestContent !=null && reportdata.liveTestContent.testStandard!=null">
                        <tbody>
                            <tr>
                                <th class="liveTestth" :style="{width:reportdata.liveTestContent.testStandard.columnName.length /100+'%'}" v-for="val in reportdata.liveTestContent.testStandard.columnName">{{val}}</th>
                            </tr>
                            <tr v-for="items in reportdata.liveTestContent.testStandard.data1">

                                <td  v-if="index == 0 && items.sameFirstCol != null" :rowspan="items.sameFirstCol"  class="liveTesttd" v-for="(item,index) in items.data">{{item}}</td>

                                 <td  v-if="index != 0 && items.sameFirstCol != null"  class="liveTesttd" v-for="(item,index) in items.data">{{item}}</td>


                               <td v-if="items.sameFirstCol == null" class="liveTesttd" v-for="item in items.data">{{item}}</td>
                            </tr>

                        </tbody>
                    </table>
                   
                    <div class="testresult"><div class="relative">{{$t('rankindex.realPeople')}}</div></div>
                    <div class="">{{$t('rankindex.testscore')}}</div>
                    <table class="report_table" v-if="reportdata.liveTestContent && reportdata.liveTestContent.resultSummary">
                        <tbody>
                            <tr class="table_bg">
                                <th class="column1">{{$t('rankindex.productName')}}</th>
                                <th v-for="item in productType" class="othercolumn table_title" :style="{width:(610/productType.length)+'px'}">{{item}}</th>
                            </tr>
                            <tr class="report_table_content" v-for="item in reportdata.liveTestContent.resultSummary">
                                <td class="column1">
                                    <!-- <div class="product_brand">SK-II</div> -->
                                    <div class="product_name">{{item.prdName}}</div>
                                    <!-- <div class="product_price">¥{{item.price}}元/{{item.unit}}</div> -->
                                </td>
                                <td v-for="val in item.livetest" :style="{width:(610/productType.length)+'px'}">
                                    <star starsize="14" :score.sync="val"></star>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    

                    <!--  -->
                    <div v-for="(item,index) in liveTestContentTitle">
                       
                        <div v-if="reportdata.liveTestContent !=null && reportdata.liveTestContent[item] != null && reportdata.liveTestContent[item].layout ==1">
                            <div class="sub_report_title sub_report_title_padding">{{sortNum[index]}}、{{item}}</div>
                            <div class="sub_report_desc" v-html="reportdata.liveTestContent[item].headcomment"></div>
                            <table class="margin_top_16" v-if="reportdata.liveTestContent[item].sheet!=null && reportdata.liveTestContent[item].sheet.length > 0">
                                <tbody>
                                    <tr>
                                        <th class="liveTestth" v-for="(item1,index1) in reportdata.liveTestContent[item].sheet[0]" :style="{width:790/Object.keys(reportdata.liveTestContent[item].sheet[0]).length+'px'}">{{index1 == 'score'?'评分':index1}}</th>
                                    </tr>
                                    <tr  v-for="(item2,index2) in reportdata.liveTestContent[item].sheet">
                                        <td  class="liveTesttd" v-for="val in item2" :style="{width:790/reportdata.liveTestContent[item].sheet[0].length+'px'}">{{val}}</td>
                                       
                                    </tr>
                                </tbody>
                            </table>
                            <div class="margin_top_24 margin_bottom_32 reality_testing_box" v-if="reportdata.liveTestContent !=null && reportdata.liveTestContent[item].imglist !=null && reportdata.liveTestContent[item].imglist.length > 0">
                                <div class="position_relative">
                                    <swiper :options="swiperOption" ref="mySwiper">
                                        <swiper-slide class="swiper-slide" v-for="(val,index) in reportdata.liveTestContent[item].imglist" :key="index">
                                            <div>
                                                <div class="banneritem">
                                                    <div  class="liveproductImg" :style="{backgroundImage:'url('+val.productImage+')'}" ></div>
                                                    <div class="display_flex justify-content_flex-justify">
                                                        <div class="reality_testing_right_content">
                                                            <div class="title">{{val.prdName}}</div>
                                                            <div>
                                                                <span class="color1 vertical-middle" style="line-height:18px;">{{item}}</span>
                                                                <star1 starsize="18" :score.sync="val.score" ></star1>
                                                            </div>
                                                            <div class="livecomment">{{val.comment}}</div>
                                                            <div class="padding_top_16 display_flex justify-content_flex-justify width_100">
                                                                <div class="livebottomImg" v-for="(values,index) in val.testImage" :style="{backgroundImage:'url('+values+')'}"></div>
                                                            </div>
                                                        </div>
                                                    </div>  
                                                </div>
                                                
                                            </div>
                                            
                                        </swiper-slide>                                                                                         
                                    </swiper>
                                    <div class="livetipstxt livetipcenter">{{$t('rankindex.piancha')}}</div>
                                   
                                    <div class="swiper-pagination indexpage"  slot="pagination"></div>
                                    <div class="swiper-button-prev"></div>
                                    <div class="swiper-button-next"></div>
                                </div>
                            </div>
                            <div class="sub_report_desc" v-html="reportdata.liveTestContent[item].footercomment"></div>
                           
                        </div>
                        <div v-if="reportdata.liveTestContent !=null && reportdata.liveTestContent[item] != null && reportdata.liveTestContent[item].layout ==2">
                            <div class="sub_report_title sub_report_title_padding">{{sortNum[index]}}、{{item}}</div>
                            <div class="sub_report_desc" v-html="reportdata.liveTestContent[item].headcomment"></div>
                            <div class="margin_top_24 margin_bottom_32 reality_testing_box" v-if="reportdata.liveTestContent !=null && reportdata.liveTestContent[item].imglist !=null && reportdata.liveTestContent[item].imglist.length > 0">
                                <div class="position_relative">
                                    <swiper :options="swiperOption" ref="mySwiper">
                                        <swiper-slide class="swiper-slide" v-for="(val,index) in reportdata.liveTestContent[item].imglist" :key="index">
                                            <div>
                                                <div class="banneritem">
                                                    <div  class="liveproductImg" :style="{backgroundImage:'url('+val.productImage+')'}" ></div>
                                                    <div class="display_flex justify-content_flex-justify">
                                                        <div class="reality_testing_right_content">
                                                            <div class="type2_right">
                                                                <div class="num">{{val.testResultValue}}</div>
                                                                <div class="desc">{{val.testResult}}</div>
                                                            </div>
                                                            <div class="title">{{val.prdName}}</div>
                                                            <div> 
                                                                <span class="color1 vertical-middle" style="line-height:18px;">{{item}}</span>
                                                                <star1 starsize="18" :score.sync="val.score" ></star1>
                                                            </div>
                                                            <div class="livecomment">{{val.comment}}</div>
                                                            <div class="padding_top_16 display_flex justify-content_flex-justify width_100" style="padding-top:24px;">
                                                                <div class="livebottomImg" v-for="(values,index) in val.testImage" :style="{backgroundImage:'url('+values+')'}"></div>
                                                            </div>
                                                        </div>
                                                    </div>  
                                                </div>
                                                
                                            </div>
                                            
                                        </swiper-slide>
                                        
                                    </swiper>
                                    <div class="livetipstxt livetipcenter">{{$t('rankindex.piancha')}}</div>
                                   
                                    <div class="swiper-pagination indexpage"  slot="pagination"></div>
                                    <div class="swiper-button-prev"></div>
                                    <div class="swiper-button-next"></div>
                                </div>
                            </div>
                            <div class="sub_report_desc" v-html="reportdata.liveTestContent[item].footercomment"></div>
                           
                        </div>
                        <div v-if="reportdata.liveTestContent !=null && reportdata.liveTestContent[item] != null && reportdata.liveTestContent[item].layout ==4">
                           <div class="sub_report_title sub_report_title_padding">{{sortNum[index]}}、{{item}}</div>
                            <div class="sub_report_desc" v-html="reportdata.liveTestContent[item].headcomment"></div>
                            
                            <div class="margin_top_24 margin_bottom_32 reality_testing_box type4_box" style="padding-top:0;">
                                <div>
                                    <div class="livetopbtn">{{reportdata.liveTestContent[item].chartTitle}}</div>
                                    <div class="livetipstxt">
                                        <span class="live_zfx"></span>{{reportdata.liveTestContent[item].sheet[0].dataDesc}}
                                    </div>
                                    <div>
                                        <div class="display_flex flex-wrap_wrap align-items_center margin_bottom_8 " v-for="item1 in reportdata.liveTestContent[item].sheet">
                                            <div class="livetest_zrd_img" :style="{backgroundImage:'url('+item1.productImage+')'}"></div>
                                            <div class="livetest_zrd_productname">{{item1.prdName}}</div>
                                            <div class="livetest_zrd_progress" style="flex:1">
                                                <div class="moistDegree_value" :style="{width:(Number(item1.value.split('%')[0])/sheetlength(item))*100+'%'}">{{item1.value}}</div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                    <div class="livetipstxt livetipcenter">{{$t('rankindex.piancha')}}</div>
                                </div>
                                
                            </div>
                            <div class="sub_report_desc" v-html="reportdata.liveTestContent[item].footercomment"></div>
                        </div>
                        <div v-if="reportdata.liveTestContent !=null && reportdata.liveTestContent[item] != null && reportdata.liveTestContent[item].layout ==3">
                           <div class="sub_report_title sub_report_title_padding">{{sortNum[index]}}、{{item}}</div>
                            <div class="sub_report_desc" v-html="reportdata.liveTestContent[item].headcomment"></div>
                            <div class="margin_top_24 margin_bottom_32 reality_testing_box" style="padding-top:0;">
                                <div>
                                    <div>
                                        <img :src="reportdata.liveTestContent[item].image" alt="" class="width_100" />
                                    </div>
                                        <div class="livetipstxt">{{$t('rankindex.piancha')}}</div>
                                    </div>
                                
                            </div>
                            <div class="sub_report_desc" v-html="reportdata.liveTestContent[item].footercomment"></div>
                        </div>
                    </div>

                    <!--  -->
                    
                    <!-- end -->
                    <!-- 小鱼护肤秘笈 -->
                    <div class="title_box">
                        <div class="report_subtitle" ref="kepu">{{$t('rankindex.report_menutips')}}</div>
                        <div class="title_line"></div>
                    </div>
                    <div v-if="reportdata.fishTips!=null ">
                        <div v-for="(item,index) in reportdata.fishTips">
                            <div class="padding_top_32" v-if="item.type == '1'">
                                <div class="tips_title">{{Object.keys(item)[1]}}</div>
                                <div class="report_tips" v-for="item in Object.values(item)[1]">
                                    <div class="question"><div class="round">Q</div>{{item.ask}}</div>
                                    <div class="answer">
                                        <div class="round">A</div>{{item.answer}}
                                        <div class="display_flex justify-content_flex-justify">
                                            <div class="limit_width_388" v-html="item.answerDesc"></div>
                                            <div class="limit_width_200" :style="{backgroundImage:'url('+item.imagepc+')'}"></div>
                                        </div>
                                       
                                        
                                    </div>

                                </div>
                            </div>
                            <!-- 面霜那些事 -->
                            <div v-if="item.type == '2'"  >
                                <div class="tips_title margin_top_32" >{{Object.keys(item)[1]}}</div>
                                    <div style="width:100%;background:#F8FBFD">

                                        <div  class="report_things" v-for="item1 in Object.values(item)[1]">
                                            <div>
                                                <img :src="item1.imagepc" alt="" class="img">
                                            </div>
                                            <div class="desc">
                                                <div class="textalign_center">{{item1.desc}} </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        
                    </div>
                    <div style="width:100%;background:#F8FBFD" v-if="reportdata.fishTips">
                        <div  class="report_things" v-for="item in Object.values(this.reportdata.fishTips)[1]">
                            <div>
                                <img :src="item.image" alt="" class="img">
                            </div>
                            <div class="desc"><div class="textalign_center">{{item.desc}} </div></div>
                        </div>
                       
                    </div>
                    <fishqcinfo></fishqcinfo>
                    <div class="report_botom_line">
                        
                    </div>

                   
                    <!-- <div  :class="['collect_btn',{'active':reportdata.favor}]" @click="collect()">{{$t('product.collectrank')}}</div> -->
                    <div>
                        <div>{{$t('rankindex.report_special')}}</div>
                        <div v-html="$t('rankindex.report_special_desc')" class="special_introductClass"></div>
                        <div  class="special_introductClass">{{$t('rankindex.report_special_desc1',[creattime1])}}</div>
                        <div  class="special_introductClass">{{$t('rankindex.report_special_desc2')}}</div>
                    </div>
                </div>
                <div class="reportmenu" :class="{'fixmenu':fixbox == true}" :style="{right:toolRight+'px'}">
                    <div class="title">{{$t('rankindex.pc_reportmenu')}}</div>
                    <div v-for="item in reportmenu">
                        <div class="title_list" @click="scrollTo(item.position)">{{item.title}}</div>
                    </div>
                </div>
                
            </div>
        </div>
        <modal ref="modaltoast" @modalthings="getmaterial"></modal>
    </div>

</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";

.margin_top_100 {
    margin-top: 100px;
}

.padding-32 {
    padding: 32px 0;
    box-sizing: border-box;
}

.padding-bottom-16 {
    padding: 0px 0 16px;
    box-sizing: border-box;
}

.margin_top_26{
    margin-top: 26px;
}
.rankRight{

}

.banner{
    height: 400px;
    background-color: #fff;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
}
.reportmenu {
    width: 384px;
    // max-height: 381px;
    padding: 0 32px 34px;
    box-sizing: border-box;
    background: #FFFFFF;
    border: 1px solid #F4F4F5;
    text-align: left;
    box-shadow: 0 10px 30px 0 rgba(233, 233, 235, 0.3);


    .title {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
        padding: 26px 0 16px;
        box-sizing: border-box;
        border-bottom: 1px solid #E5E5E5;
    }

    .title_list {
        margin-top: 16px;
        box-sizing: border-box;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        line-height: 24px;
        position: relative;
        padding-left: 16px;
        cursor: pointer;

        &:hover {
            color: #60DEB4;
        }

        &:before {
            content: '';
            position: absolute;
            left: 0%;
            top: 50%;
            transform: translate(0, -50%);
            width: 8px;
            height: 8px;
            background: #60DEB4;
            border-radius: 56px;

        }

        .active {
            color: #60DEB4;
        }
    }
}

.padding_16 {
    padding: 16px 0;
    box-sizing: border-box;
}

.reportcontian {
    width: 792px;
    text-align: left;

    .report_title {
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 48px;
    }

    .report_collect {
        display: inline-block;
        width: 64px;
        height: 24px;
        line-height: 24px;
        background: #60DEB4;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        letter-spacing: 3px;
        text-align: center;
    }

    .report_time {
        line-height: 24px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #888888;
        padding-right: 30px;
        box-sizing: border-box;
    }

    .report_desc {
        font-size: 16px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;
        text-align: justify;
    }

    .report_subtitle {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #262633;
        line-height: 32px;
        padding-bottom: 18px;
        display: inline-block;
        
        padding-left: 2px;
        box-sizing: border-box;

    }

    .title_box {
        padding-top: 32px;
        box-sizing: border-box;

        .title_line {
            margin-top: -2px;
            height: 2px;
            background: #F4F4F5;
            position: relative;
            &:before{
                width: 120px;
                height: 4px;
                background: #60DEB4;
                content:'';
                position: absolute;
                left:0;
                top:-1px;
            }
        }
    }

    .testresult {
        padding: 32px 0 8px 16px;
        box-sizing: border-box;
        font-size: 20px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #262633;
        line-height: 32px;
        
        .relative{
            position: relative;
            &:before {
                content: '';
                position: absolute;
                left: -16px;
                top: 50%;
                transform: translate(0, -50%);
                width: 8px;
                height: 8px;
                background: #60DEB4;
                border-radius: 56px;

            }
        }
        
    }
    .testresult_vs{
        width: 42px;
        height: 42px;
        background: #D5D5D7;
        display: inline-block;
        border-radius: 50%;
        font-size: 21px;
        font-family: Arial-BoldMT, Arial;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 42px;
        text-align: center;
        vertical-align: middle;
        margin:104px 30px 0;
    }

    .padding_top_38{
        padding: 38px 0 22px;
        box-sizing: border-box;
    }
    .result1 {
        padding-left: 16px;
        box-sizing: border-box;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;
        text-align: justify;
    }

    .resultNum {
        font-size: 40px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262633;
        line-height: 40px;
        padding-bottom: 10px;
    }

    .resultdesc {
        padding-top: 10px;
        font-size: 12px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #51515C;
        line-height: 14px;
        position: relative;


        &:before {
            content: '';
            position: absolute;
            top: 0;
            width: 40px;
            height: 1px;
            background-color: #F4F4F5;
            left: 0;

        }
    }

    .padding_top_28 {
        // padding-top: 28px;
        padding-left: 46px;
        box-sizing: border-box;
    }

    .padding_top_20 {
        // padding-top: 20px;
        padding-right: 20px;
        box-sizing: border-box;
    }

    .padding_right_184 {
        padding-right: 184px;
        box-sizing: border-box;
    }

    .padding_right64 {
        padding-right: 64px;
        box-sizing: border-box;
    }

    .padding_left_42 {
        padding-left: 12px;
        box-sizing: border-box;
    }

    .fishdesc {
        text-align: center;
        font-size: 16px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #51515C;
        padding-top: 8px;
        box-sizing: border-box;
    }

    .fishimg {
        position: absolute;
        left: 22px;
        top: 50%;
        transform: translate(0, -50%);
    }

    .fishqcround {
        width: 80px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        display: inline-block;
        background-image: url('http://p1.fishqc.net/FjD4dfCGmBJ33_K3UcPUinzSx0De');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
        // background-color: #53D5C2;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        border-radius: 50%;
        margin-left: 71px;
        padding-left: 12px;
        box-sizing: border-box;

        &.green {
            background-image: url('http://p1.fishqc.net/FjD4dfCGmBJ33_K3UcPUinzSx0De');
            
        }

        &.yellow {
            background-image: url('http://p1.fishqc.net/FrPm2bdeg_rnsLAmFWyownHKIfNK');
            
        }

        &.red {
            background-image: url('http://p1.fishqc.net/FtiOu41M-4kaQu-l0uxLbvxrFEZd');
           
        }

        &.grave {
            background-image: url('http://p1.fishqc.net/FvyRjPY9ceyjmo3xS6t9e_0Jve2i');
        }

        &.margin_left0 {
            margin-left: 0;
        }
    }

    .desc2 {
        padding-top: 26px;
        box-sizing: border-box;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;
        text-align: justify;
    }

    .desc3 {
        padding-top: 24px;
        font-size: 16px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;
        text-align: justify;
    }

    .rankItem {
        .rankItem_productimg {
            width: 148px;
            height: 100%;
            background-image: url('http://p1.fishqc.net/FiVwYzbfQSdgjBZRGyqwknMlLTyb!product.thumb');
            background-size: contain;
            background-position: center center;
            background-repeat: no-repeat;
        }

        .product_title {
            padding-top: 14px;
            box-sizing: border-box;
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #353C46;
            line-height: 24px;
            padding-right: 10px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            .productname{
                padding-right:10px;
                box-sizing:border-box;
                @include linelimt(2);
            }
        }

        .product_bable {
            margin: 8px 0 0px;
            padding: 6px 16px 6px 10px;
            box-sizing: border-box;
            background-color:#43A0AC;
            font-size: 9px;
            line-height: 9px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #fff;
            display: inline-block;
            position: relative;
            border-radius: 0 0 0 9px;
            &:after {
                content: '';
                position: absolute;
                right: -10px;
                top: 0;
                width: 22px;
                height: 21px;
                background-image: url('http://p1.fishqc.net/FujtO5kFbA_ovum4FQIsxSQBvCVN');
                background-size: contain;
                background-position: 0px center;
                background-repeat: no-repeat;
            }
        }

        .productdetail {
            margin: 0px 32px 16px 0;
            box-sizing: border-box;
        }

        .productitemdetail {
            font-size: 12px;

            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #9B9B9B;

            .productitemdetails {
                padding: 6px 0;
                border-bottom: 1px solid #F8F8F8;

                &:last-child {
                    border-bottom: none;
                    padding-bottom: 0;
                }

                .color {
                    color: #333;
                }

                .fix-width-60 {
                    width: 76px;
                    display: inline-block;
                }
            }
        }
    }

    .secondtitle {
        padding: 0 0 10px 16px;
        box-sizing: border-box;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262633;
        line-height: 32px;

        &.padding_top_24 {
            padding-top: 24px;
            box-sizing: border-box;
        }
    }
}

.rankItem {
    width: 384px;
    height: 184px;
    margin-top: 24px;
    border: 1px solid #F4F4F5;
    margin-right: 20px;
    cursor: pointer;
    &:nth-of-type(2n) {
        margin-right: 0;
    }
}

.fishblock {
    width: 100%;
    height: 120px;
    background-color: #EBFFFE;
    padding-left: 36px;
    box-sizing: border-box;
    margin-bottom: 24px;
    padding-top: 32px;

    &:nth-of-type(1) {
        margin-top: 32px;
    }

    &.green {
        background: #EBFFFE;
    }

    &.yellow {
        background: #FFFDF1;
    }

    &.red {
        background: #FFF5F1;
    }

    .padding_left_16 {
        padding-left: 16px;
        box-sizing: border-box;
    }

    .title {

        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #53D5C2;
        line-height: 22px;
        padding-bottom: 10px;
        box-sizing: border-box;

        &.yellowcolor {
            color: #FFC72F;
        }

        &.redcolor {
            color: #FF8437;
        }
    }

    .desc {

        font-size: 16px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: #51515C;
        line-height: 16px;
    }


}

.desc4 {
    padding-top: 6px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 28px;
    text-align: justify;
}

.tiaochacontain {
    padding: 0 10px 0 42px;
    box-sizing: border-box;
}

.tiaochaimg {
    padding-top: 24px;
    box-sizing: border-box;
}

.tiaochatxt {
    padding-top: 14px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #60DEB4;
    line-height: 24px;
}

.padding_left_16 {
    padding-left: 16px;
    box-sizing: border-box;
}

.desc5 {
    padding: 0 0 16px 0px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 28px;
}

.reportinfo_text {
    width: 278px;
    height: 61px;
    background: #FFFFFF;
    border-radius: 40px;
    border: 1px solid #DBDCDC;
    position: absolute;
    right: -278px;
    bottom: 8px;
    padding: 6px 20px 0 56px;
    box-sizing: border-box;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262633;
    line-height: 24px;

    .position_left {
        position: absolute;
        left: -36px;
        top: -12px;
    }
}

.reportinfo_img1 {
    width: 484px;
    height: 293px;
    background-color: #eee;
}

.reportinfo_img2 {
    width: 369px;
    height: 200px;
    line-height: 200px;
    background-color: #666;
    text-align: center;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
}

.reportinfo_img3 {
    width: 238px;
    height: 200px;
    line-height: 200px;
    background-color: #666;
    text-align: center;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
}

.vs-right-ul_left {
    padding-left: 24px;
    box-sizing: border-box;
}

.vs-right-li {
    height: 32px;
    line-height: 32px;
    background: #F0FFFC;
    border-radius: 16px;
    background-color: #F0FFFC;
    font-size: 16px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #60DEB4;
    padding: 0 20px 0 30px;
    margin-bottom: 14px;
    display: inline-block;
    position: relative;

    &:before {
        content: '';
        width: 13px;
        height: 13px;
        display: inline-block;
        border-radius: 50%;
        background-color: #60DEB4;
        position: absolute;
        left: 9px;
        top: 10px;
    }

    &.grave{
        color:#A8A8AD;
        background-color: #F4F4F5;
        padding:0  15px ;
        margin-left: 13px;
        &:before {
            content: '';
            width: 13px;
            height: 13px;
            display: inline-block;
            border-radius: 50%;
            background-color: #A8A8AD;
            position: absolute;
            left: -19px;
            top: 10px;
        }
    }
}

.padding_top_24 {
    padding-top: 24px;
    box-sizing: border-box;
}

.desc6 {
    padding: 16px 0;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262633;
    line-height: 28px;
}

.desc7 {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 32px;
    padding-bottom: 22px;
}

.desc8 {
    padding-left: 30px;
    font-size: 16px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #51515C;
    line-height: 28px;
    text-align: justify;
}

.desc9 {
    padding-bottom: 16px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 28px;
    text-align: justify;

    .strong {
        font-weight: bold;
    }
}

.padding_top_32 {
    padding-top: 32px !important;
    box-sizing: border-box;
}

.padding_bottom_30 {
    padding-bottom: 30px;
    box-sizing: border-box;
}

.fishqc_tech_title {
    box-sizing: border-box;
    font-size: 18px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #262633;
    line-height: 26px;
    width:260px;
    padding-left: 40px;
    
    span{
        font-size: 18px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #262633;
        line-height: 26px;
    }
    &.lie2{
        width:240px;
        padding-left: 40px;
        text-align: justify;
    }

    &.lie3{
        width:200px;
        padding-left: 40px;
    }

    &.lie4{
    }

    &.margin_left_42 {
        margin-left: 42px;
    }

    &.margin_left_50 {
        margin-left: 50px;
    }


}

.height_80 {
    width: 100%;
    height: 80px;
    padding-top: 14px;
    box-sizing: border-box;
    background-color: #F8FBFD;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 30px;
}

.height_150 {
    width: 100%;
    height: 150px;
    background-color: #F1FFFA;
    padding-top: 32px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 30px;
}

.height_150_yellow {
    width: 100%;
    height: 150px;
    background-color: #FFFDF1;
    padding-top: 32px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 30px;
}

.height_150_red {
    width: 100%;
    height: 150px;
    background-color: #FFF5F1;
    padding-top: 16px;
    box-sizing: border-box;
}

.speaker{
    width: 180px;
    font-size: 16px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #51515C;
    line-height: 28px;
    text-align: justify;
}

.speaker_bottom{
    width: 180px;
    height: 51px;
    background: #60DEB4;
    border-top:2px solid #262633;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262633;
    line-height: 12px;
    text-align: center;
    position: relative;
    z-index: 2;
    &:before{
        content:'';
        position: absolute;
        width: 130px;
        height: 219px;
        background: url('http://p1.fishqc.net/FnA_LoKjuQV0BIrVvseiRdjsCNtc') center center no-repeat;
        left:50%;
        bottom:53px;
        transform: translate(-50%,0);
        
    }
    .title{
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262633;
        line-height: 24px;
        margin-bottom: 4px;
    }
}


.collect_btn{
    width: 144px;
    height: 48px;
    background: #FFFFFF;
    border: 1px solid #60DEB4;
    margin:0px auto 62px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #60DEB4;
    line-height: 48px;
    letter-spacing: 4px;
    padding-left:66px;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;
   &:before{
        content:'';
        position: absolute;
        left: 38px;
        top:50%;
        transform:translate(0,-50%);
        width:20px;
        height: 20px;
        background-image: url('http://p1.fishqc.net/Flc4z_hWNfyrvJfg1gMSux-xxqAG');
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
   }
   &.active{
        &:before{
            content:'';
            position: absolute;
            left: 38px;
            top:50%;
            transform:translate(0,-50%);
            width:20px;
            height: 20px;
            background-image: url('http://p1.fishqc.net/FoKkNmGg00gPWcvsodcw43dcIc6n');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: contain;
       }
   }
}
.collect_btn_top{
    width: 144px;
    height: 48px;
    background: #FFFFFF;
    border: 1px solid #60DEB4;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #60DEB4;
    line-height: 48px;
    letter-spacing: 4px;
    padding-left:40px;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;
    width: 88px;
    height: 32px;
    line-height:32px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #60DEB4;
    display: inline-block;
   &:before{
        content:'';
        position: absolute;
        left: 16px;
        top:50%;
        transform:translate(0,-50%);
        width:18px;
        height: 18px;
        background-image: url('http://p1.fishqc.net/Flc4z_hWNfyrvJfg1gMSux-xxqAG');
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
   }
   &.active{
        &:before{
            content:'';
            position: absolute;
            left: 16px;
            top:50%;
            transform:translate(0,-50%);
            width:18px;
            height: 18px;
            background-image: url('http://p1.fishqc.net/FoKkNmGg00gPWcvsodcw43dcIc6n');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: contain;
       }
   }
}
.report_botom_line{
    border-top:1px solid  #E5E5E5;
    margin:64px 0 32px;

}

.special_introductClass{ 
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #424242;
    line-height: 24px;
    margin-top: 16px;
    text-align: justify;
}

.peoper_desc{
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #424242;
    line-height: 28px;
    padding:26px 0;
    box-sizing: border-box;
    text-align: justify;
    &.padding{
        padding:32px 0 20px;
        box-sizing: border-box;
    }

}
.report_table{
    margin-bottom: 32px;
    border: 1px solid #CFF5E8;
    box-sizing: border-box;
    margin-top: 16px;
    tr>th,tr>td{
        width: 99px;
        text-align: center;
        vertical-align: middle;
    }
    tr>th:nth-child(1){
        width: 182px;
        text-align: center;
        border: 1px solid #CFF5E8;
    }
    tr>td{
        padding:4px 0 6px;
        box-sizing: border-box;

    }
    tr>td:nth-child(1){
        width: 182px;
        text-align: center;
        padding-left: 20px;
        box-sizing: border-box;
        text-align: left;
    }

    tr.report_table_content:nth-child(odd){
        background-color:#F8FBFD; 
    }
    tr.report_table_content:nth-child(even){
        background-color: #FCFEFE;
    }

    tr.report_table_content td{
        border-left: 1px solid #CFF5E8;
        border-right: 1px solid #CFF5E8;
        box-sizing: border-box;
    }
    .product_brand{
        font-size: 16px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #424242;
        line-height: 20px;
         
    }

    .product_name{
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #424242;
        line-height: 20px;
        padding-right:10px;
        box-sizing:border-box;
         
    }

    .product_price{
        display: inline-block;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 17px;
        background: linear-gradient(324deg, #28D877 0%, #0DC6B8 100%);
        border-radius: 0px 14px 10px 10px;
        padding:2px 7px;
        box-sizing: border-box;
    }
    .position_center{
        width: 100%;
        @include center;
    }

    .table_bg{
        width:792px;
        line-height:64px;
        background: rgba(96, 222, 180, 0.2);
        
        .column1{
            width: 182px;
            text-align: center;
            font-family: PingFangSC-Medium;
        }

        .othercolumn{
            width: 122px;
            text-align: center;


        }
    }
    .table_title{
        font-size: 18px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #424242;
        line-height: 64px;
        border: 1px solid #CFF5E8;
        box-sizing: border-box;
    }
}

.margin_bottom_32{
    margin-bottom: 32px;
}
.reality_testing_box{
    width: 100%;
    background-color: #F8FBFD;
    text-align: center;
    padding: 32px 0px 38px 32px;
    box-sizing: border-box;
    .reality_testing_title{
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 40px;
        background: #60DEB4;
        border-radius: 20px;
        display: inline-block;
        padding:0 26px;
        box-sizing: border-box;
    }
    .reality_testing_desc{
        padding:16px 0px;
        box-sizing: border-box;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #424242;
        line-height: 28px;
        text-align: left;
    }

    .reality_testing_img{
        width: 310px;
        height: 174px;
        background: #60DEB4;
    }

    .reality_testing_right_content{
        width:500px;
        position: relative;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #424242;
        line-height: 24px;
        text-align: justify;
        .title{
            font-size: 16px;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            padding-top: 34px;
            box-sizing: border-box;
        }

        .color1{
            padding-right: 2px;
            color: #9A9A9A;
        }
        .productImg{
            width: 90px;
            height: 90px;
            background-image: url('http://p1.fishqc.net/FiVwYzbfQSdgjBZRGyqwknMlLTyb!product.thumb');
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
            position: absolute;
            right:-10px;
            top:-20px;
        }
        .xingzhi{
            height: 32px;
            line-height:32px;
            background: #F4FCFA;
            border-radius: 0px 100px 100px 10px;
            display: inline-block;
            padding:0 10px;
            box-sizing: border-box;
            margin:8px 0;
            .xingzhi_num{

                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #60DEB4;
            }
        }

        .type2_right{
            position: absolute;
            top:24px;
            right:30px;
            .num{
                width: 48px;
                height: 48px;
                border-radius: 50%;
                background-color: #60DEB4;
                text-align:center;
                line-height:48px;
                font-size: 32px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
            }
            .desc{
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 24px;
                text-align: center;
            }
        }
    }
}
.padding_top_32{
    padding-top: 32px;
    box-sizing: border-box;
}
.report_tips{
    padding:32px 60px 30px 48px;
    box-sizing: border-box;
    &:nth-child(odd){
        background:#E9FBEB;
        opacity: 1;
    }
    &:nth-child(even){
        
        background:#CFF5E8;
        opacity: 1;
    }
    
    .round{
        width: 32px;
        height: 32px;
        background: linear-gradient(270deg, #28D877 0%, #0DC6B8 100%);
        position: absolute;
        text-align: center;
        line-height:32px;
        font-size: 20px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 32px;
        left:24px;
        top:24px;
        border-radius:50%;
    }
    .question{
        max-width: 420px;
        background: #FFFFFF;
        border-radius: 0px 16px 16px 16px;
        font-size: 18px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #333333;
        line-height:32px;
        padding:24px 20px 30px 72px;
        box-sizing: border-box;
        margin-bottom:24px;
        position: relative;

    }
    .answer{
        width: 686px;
        background: #FFFFFF;
        border-radius: 0px 16px 16px 16px;
        font-size: 18px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #333333;
        line-height:32px;
        padding:24px 20px 30px 72px;
        box-sizing: border-box;
        position: relative;
        text-align: justify;
        .detail{
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 28px;
        }
        .answer_img{
            position: absolute;
            right:12px;
            top:-128px;
        }

    }

}
.report_img{
    width: 50%;
    display: inline-block;
    text-align: center;
    margin:20px 0;
}
.tr_margin{
    padding-top: 22px;
}
.report_things{
    width: 50%;
    display: inline-block;
    text-align: center;
    vertical-align: top;

    
    .desc{
        margin:20px 0 34px;
        line-height: 26px;
        vertical-align: top;
    }
}

.fixmenu{
    position: fixed;
    top:32px;
}

.margin_bottom_32{
    margin-bottom: 32px;
}

.sub_report_title{
    font-size: 24px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: #424242;
    line-height: 32px;
    &.sub_report_title_padding{
        padding:26px 0 16px;
        box-sizing: border-box;
    }

}
.sub_report_desc{
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #424242;
    line-height: 28px;
    text-align: justify;
    padding-top: 20px;
    box-sizing: border-box;
}


.atresult_desc{
    text-align:center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #424242;
    line-height: 28px;
    &.textalign_left{
        text-align: left;
    }
}

.ingre{
    line-height: 48px;
    font-size: 14px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    display: inline-block;
    text-align:center;
    background-color: #FAFAFA;
    border: 1px solid #E8E8E8;
    box-sizing: border-box;
    &.width_120{
        width:120px;
    }
    &.width_430{
        width:424px;
    }
}
.ingre_content{
    line-height: 18px;
    font-size: 14px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.65);
    display: inline-block;
    text-align:center;
    background-color: #FAFAFA;
    border: 1px solid #E8E8E8;
    padding:10px;
    box-sizing: border-box;
    &.width_120{
        width:120px;
    }
    &.width_430{
        width:424px;
    }
}
.margin_top_16{
    margin-top: 16px;
}
.padding_top_16{
    padding-top: 16px;
    box-sizing: border-box;
}
.padding_bottom_24{
    padding-bottom: 24px;
    box-sizing: border-box;
}
.green_desc{
    padding-left: 20px;
    box-sizing: border-box;
    position: relative;
    display: inline-block;
    margin-right: 24px;
    &:before{
        content:"";
        position: absolute;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #60DEB4;
        left:0;
        top:50%;
        transform: translate(0,-50%);
    }
}
.yellow_desc{
    padding-left: 20px;
    box-sizing: border-box;
    position: relative;
    display: inline-block;
    margin-right: 24px;
    &:before{
        content:"";
        position: absolute;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #FFDB69;
        left:0;
        top:50%;
        transform: translate(0,-50%);
    }
}
.red_desc{
    padding-left: 20px;
    box-sizing: border-box;
    position: relative;
    display: inline-block;
    &:before{
        content:"";
        position: absolute;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #FF7467;
        left:0;
        top:50%;
        transform: translate(0,-50%);
    }
}

.width_50{
    width:50%;
    display: inline-block;
    vertical-align: top;
}
.product_detail_effecttxt {
    font-size: 20px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: #424242;
    line-height: 32px;
    height: 32px;
    position: relative;
    .product_detail_effecttxtbg {
        width: 64px;
        height: 8px;
        background: #60DEB4;
        margin: 0 auto;
        position: absolute;
        bottom: 8px;
        left: 0%;
        transform: translate(0%, 0);
    }

    .effectresult {
        position: absolute;
        width: 100%;
        display: block;
        font-family: PingFangSC-Medium;
        
    }
    &.small{
        line-height:22px;
        height: 22px;
        .effectresult{
            font-size: 16px;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            color: #000000;
            line-height: 22px;
            -webkit-background-clip: text;
        }
        .product_detail_effecttxtbg{
            bottom: 4px;
        }
        
    }

}
.place{
    width: 330px;
    font-size: 16px;
    font-family:  PingFang SC;
    font-weight: 400;
    color: #424242;
    line-height: 28px;
    padding-top: 8px;
    box-sizing: border-box;
    padding-right: 20px;
}
.placeresult{
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #424242;
    line-height: 28px;
}

.price_standard{
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #424242;
    line-height: 20px;

    .bigger{
        font-size: 14px;
        vertical-align: middle;
    }
    .arr{
        font-size: 5px;
        vertical-align: middle;
        margin-right: 10px;
    }

    .price_distance{
        width:4px; 
        height: 32px;
        background-color: #6080DE;
        margin:0 8px;
        display: inline-block;
        vertical-align: middle;
    }
}

.position_absulute{
    position: absolute;
    right: 50px;
    top:50%;
    transform: translate(0,-50%);
}
.padding_left_28{
    padding-left: 28px;
    box-sizing: border-box;
}
.beishu{
    font-size: 24px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #424242;
    line-height: 42px;
}
.margin_right_10{
    margin-right: 10px;
}

.tips_title{
    display: inline-block;
    height: 40px;
    line-height:40px;
    font-size: 20px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: #FFFFFF;
    background: #60DEB4;
    border-radius: 10px 32px 0px 0px ;
    padding:0 26px 0 14px;
    box-sizing: border-box;
}
.margin_top_32{
    margin-top: 32px;
}
.liveTestth{
    height: 48px;
    line-height:48px;
    background: #FAFAFA;
    border-radius: 4px 0px 0px 0px;
    text-align:center;
    border:1px solid  #E8E8E8;
    box-sizing: border-box;
    font-size: 14px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    &.width_120{
        width: 120px;
    }
    &.width_178{
        width: 178px;
    }
    &.width_480{
        width: 480px;
    }
}
.liveTesttd{
    padding:6px 24px;
    box-sizing: border-box;
    line-height: 24px;
    background: #fff;
    border-radius: 4px 0px 0px 0px;
    text-align:center;
    border:1px solid  #E8E8E8;
    box-sizing: border-box;
    font-size: 14px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    &.width_120{
        width: 120px;
    }
    &.width_178{
        width: 178px;
    }
    &.width_480{
        width: 480px;
    }
}
.margin_top_24{
    margin-top:24px;
}

.liveproductImg{
    position: absolute;
    left:10px;
    top:10px;
    width: 110px;
    height: 110px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    // background-color: yellow;

}

.livecomment{
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #424242;
    line-height: 24px;
}

.livebottomImg{
    width:500px;
    height: 264px;
    // background-color: pink;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    &:nth-of-type(2){
        margin-left: 24px;
    }
}

.livetipstxt{
    font-size: 14px;
    font-family:PingFang SC;
    font-weight: 400;
    color: #9A9A9A;
    line-height: 24px;
    padding-top: 20px;
    box-sizing: border-box;
    &.livetipcenter{
        text-align: center;
        width: 656px;
    }
}

.livetopbtn{
    display: inline-block;
    padding:0 34px;
    box-sizing: border-box;
    height: 40px;
    line-height: 40px;
    background: linear-gradient(270deg, #28D877 0%, #0DC6B8 100%);
    border-radius: 0px 0px 24px 24px;
    font-size: 18px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
}

.live_zfx{
    width: 16px;
    height: 16px;
    background-color: #5B8FF9;
    display: inline-block;
    vertical-align: middle;
    margin-right: 16px;
}
.margin_bottom_8{
    margin-bottom: 8px;
}
.livetest_zrd_img{
    width: 56px;
    height: 56px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}

.livetest_zrd_productname{
    width: 96px;
    font-size: 14px;
    font-family: Helvetica;
    color: #888888;
    line-height: 16px;
    text-align: right;
    margin-left: 4px;
    margin-right: 12px;
}

.livetest_zrd_progress{
    // max-width: 200px;
    background-color: #e9e9eb;
    height: 37px;
    line-height:37px;
    font-size: 16px;
    font-family: Helvetica;
    color: #f6f6f6a1;
    
    box-sizing: border-box;
    border-radius: 0px 38px 38px 0;
    .moistDegree_value{
        background-color: #5b8ff9;
        font-size: 16px;
        font-family: Helvetica;
        color: #f6f6f6;
        text-align: left;
        padding-left:20px;
        box-sizing: border-box;
        border-radius: 0px 38px 38px 0;
        // padding:0 8px;
    }

}
.padding_left_110{
    padding-left: 110px;
    box-sizing: border-box;
}
.padding_left_70{
    padding-left: 70px;
    box-sizing: border-box;
}
.round_desc{
    font-size: 14px;
    font-family:PingFang SC;
    font-weight: 400;
    color: #424242;
    line-height: 20px;
    .relative{
        position: relative;
        &.green:before{
            content: "";
            position: absolute;
            left: -16px;
            top: 50%;
            transform: translate(0, -50%);
            width: 10px;
            height: 10px;
            background: #60DEB4;
            border-radius: 56px;
        }
        &.yellow:before{
            content: "";
            position: absolute;
            left: -16px;
            top: 50%;
            transform: translate(0, -50%);
            width: 10px;
            height: 10px;
            background: #FFDB69;
            border-radius: 56px;
        }
        &.red:before{
            content: "";
            position: absolute;
            left: -16px;
            top: 50%;
            transform: translate(0, -50%);
            width: 10px;
            height: 10px;
            background: #FF7338;
            border-radius: 56px;
        }
    }
}
.eeqprogressclass >>>  path:first_child{
    stroke: red;
    stroke-width:1; 
}
.el-progress-circle svg path:first_child{
    stroke: rgba(244,244,245,1);
    fill: rgba(244,244,245,1);
    stroke: red;
    fill: red;
}

.el-progress-circle__track{
    stroke: red;
}

.green_round{
    display: inline-block;
    width: 8px;
    height: 8px;
    background: #60DEB4;
    border-radius: 50%;
    margin: 0px auto 10px;
    &:nth-of-type(1){
        margin: 10px auto 6px;
    } 

}
.yellow_round{
    display: inline-block;
    width: 8px;
    height: 8px;
    background: #FFDB69;
    border-radius: 50%;
    margin: 0px auto 10px;
    &:nth-of-type(1){
        margin: 10px auto 6px;
    } 

}
.red_round{
    display: inline-block;
    width: 8px;
    height: 8px;
    background: #FF7338;
    border-radius: 50%;
    margin: 0px auto 10px;
    &:nth-of-type(1){
        margin: 10px auto 6px;
    }
}

.limit_width_388{
    width: 388px;
}
.limit_width_200{
    width: 200px;
    height: 200px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;


}

.type4_box{
    padding-top: 0px;
    background: #fff;
    border-radius: 8px;
    border: 8px solid #F8FBFD;
    padding-right: 20px;
    box-sizing: border-box;
}
</style>
<style type="text/css" lang="scss">
.banneritem{
    width: 656px;
    padding:0 30px 30px 118px;
    box-sizing: border-box;
    min-height: 174px;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100%;
    position: relative;

}
/* 轮播图 */
// .swiper-container {
//     width: 100%;
//     height: 100%;
// }


// .swiper-slide {
//     width: 656px;
//     background-position: center;
//     background-size: cover;
//     display: inline-block;

// }

// .index-swpier {
//     .swiper-pagination-bullet {
//         width: 8px;
//         height: 8px;
//         background: #E5E5E5;
//         border-radius: 4px;

//         &.swiper-pagination-bullet-active {
//             width: 16px;
//             height: 8px;
//             background: #76E2D2;
//             border-radius: 4px;

//         }


//     }

//     .swiper-pagination-fraction,
//     .swiper-pagination-custom,
//     .swiper-container-horizontal>.swiper-pagination-bullets {
//         left: 0;
//         bottom: 0px;
//         transform: translate(50%, -10%);
//         width: auto
//     }

// }

// .indexpage{
//     &.swiper-pagination-fraction,&.swiper-pagination-custom, &.swiper-container-horizontal > .swiper-pagination-bullets{
//         width:656px;
//         padding-right: 42px;
//         box-sizing: border-box;
//         font-size: 14px;
//         font-family:  PingFang-SC;
//         font-weight: 400;
//         color: #888888;
//         line-height: 10px;
//         text-align: right;
//     }

//     .swiper-pagination-bullet {
//         width: 8px;
//         height: 8px;
//         background: #E5E5E5;
//         border-radius: 4px;

//         &.swiper-pagination-bullet-active {
//             width: 16px;
//             height: 8px;
//             background: #76E2D2;
//             border-radius: 4px;

//         }


//     }

//     .swiper-pagination-fraction,
//     .swiper-pagination-custom,
//     .swiper-container-horizontal>.swiper-pagination-bullets {
//         left: 0;
//         bottom: 0px;
//         transform: translate(50%, -10%);
//         width: auto
//     }


// }
// .swiper-button-prev, .swiper-container-rtl .swiper-button-next{
//     width:32px;
//     height: 32px;
//     background-image:url('http://p1.fishqc.net/FsjOiCTGGZB3He1qZnpITEQDxxFr');
//     background-repeat: no-repeat;
//     background-position: center center;
//     background-size: 28px 28px;
//     top: auto;
//     right: 186px;
//     left: auto;
//     bottom: 0;

//     &:after{
//         content:''
//     }
// }
// .swiper-button-next, .swiper-container-rtl .swiper-button-prev {
//     width:32px;
//     height: 32px;
//     background-image:url('http://p1.fishqc.net/Fnz0wG6E5eCZnRAPQj5iyMjT-v-y');
//     background-repeat: no-repeat;
//     background-position: center center;
//     background-size: 28px 28px;
//     top: auto;
//     right: 104px;
//     left: auto;
//     bottom: 0;
//     &:after{
//         content:''
//     }
// }
// .swiper-pagination1,.swiper-pagination2{
//     position: absolute;
//     text-align: center;
//     transition: 300ms opacity;
//     transform: translate3d(0, 0, 0);
//     z-index: 10;

// }
</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import fishqcinfo from '@/components/fishqcInfo.vue'
import star from '@/components/star.vue'
import { pwc_getreportdetailApi ,collectApi } from '@/api/api.js'
import { myMixin } from '@/mixin/mixin.js'
import { getMaxSort} from '@/utils/other.js'
import {formatTime} from '@/utils/other.js'
import Modal from '@/components/Modal.vue'
export default {
    name: '',
    components: {
        banner,
        fishqcinfo,
        star:star,
        star1:star,
        modal:Modal
    },
    mixins: [myMixin],
    data() {
        return {
            special_introduct:"1，此测试结果根据随机抽样的原则，并符合实验室测试的方法和标准，所有试验样品的采购均由本机构员工以普通消费者身份，通过正规销售管道完成。<br> 2，绿鱼标签表示产品品量卓越。 <br>3，绿鱼榜单皆为本次测试质量卓越的产品，排名不分先后。<br> 4，所有试验均由水中银在香港、台湾或者比利时的认证实验室完成。<br> 5，本次测试根据消费品比较试验的原则进行。本次比较试验结果仅对样品负责，不代表同品牌相同或不同型号、不同批次产品的质量状况。结果仅供参考，不构成对任何相关产品的推荐与宣传，不应被视为医学建议和意见。在使用测试结果之前，应先咨询医务人员或医疗专业人员，有关结果并不能视为诊断或治疗任何医疗或健康状况的信息或建议。本机构亦不会对任何人或此报告内容承担任何的责任。 <br>6，本次测试所提供之测试报告及任何与产品质量有关的评价、推荐等内容仅供用户参考，不具有担保效力或者任何法律效力，用户做出的商业或者消费决策，属于用户独立自主之行为，由此而产生的任何纠纷或者争议与本机构无关，本机构对此不承担任何责任。<br> 7，未经许可，任何企业、机构不得利用本次测试结果刊登广告或从事其他促销、宣传、推广活动。 <br>8，报告中所有信息和数据截至2019年10月24日，并会结合相关权威机构检测结果不断更新。<br> 9，欲了解更多信息，请参见条款，条件和用户协议。<a href='http://www.fishqc.com/pdf/Terms_and_Conditions.pdf' target='_blank'>http://www.fishqc.com/pdf/Terms_and_Conditions.pdf</a>",
            // productType:[
            //     {
            //         name:'质感',
            //         desc:'面霜的质地是否好推开、涂抹在皮肤的感觉是否轻盈舒爽、气味是否宜人等因素都会影响着使用感受，本次测试将会从质地开始，为大家展示以下热销面霜的使用感受。',
            //     },
            //     {
            //         name:'保湿度',
            //         desc:'保湿补水是面霜最重要的功能，我们将使用保湿仪对使用面霜前后油分和水分的数据进行一个对比，测试每一个产品的保湿补水度，测试结果如下：',
            //     },
            //     {
            //         name:'亲肤性',
            //         desc:"<div style='font-family:  PingFang SC'>根据轻工行业标准《QB/T 1857-2013 润肤膏霜》,霜类的pH值在4.0-8.5都是满足要求的，而根据《广东省化妆品质量管理协会》提出健康人体皮肤一般最佳酶活性pH值会稳定在5.5，因此pH值在5.5左右的润肤霜对皮肤是最温和，亲肤性最好测试结果如下：</div><div style='font-family: PingFangSC-Medium;font-weight: 500;margin-top:8px;'>除了兰芝新水酷特润乳霜ph值为6以外，其它ph值均为5-5.5值。鉴于pH值在5.5~7.0的润肤霜对皮肤最温和，这些面霜亲肤性都很好，有利于肌肤酸碱平衡，都是很温和的产品。</div>",
            //     },
            //     {
            //         name:'延展性',
            //         desc:"<div style='font-family:  PingFang SC'>取一样克数的面霜放在皮革上，用胶棒把它们延展开来，根据皮革上面霜延展的长度和延展轨迹来评价一款面霜的延展性，延展的长度越长，轨迹越规整，其延展性评价则为顺滑均匀。</div><div style='font-family: PingFangSC-Medium;font-weight: 500;margin-top:8px;'>8款面霜的延展性都不错，基本都能延展20厘米的距离，值得说一下的是FANCL芳珂、CUREL珂润和LA ROCHE-POSAY理肤泉这三款面霜的延展都非常均匀和顺滑。</div>",
            //     },
            //     {
            //         name:'滋润度',
            //         desc:'把相同克数的面霜涂抹在皮肤上，然后将吸油纸吸附在肌肤上，根据吸油纸上的油脂面积来评价一款面霜的滋润度，吸油纸上油脂面积越大则为越滋润。',
            //     },
            //     {
            //         name:'清爽度',
            //         desc:"<div style='font-family:  PingFang SC'>取相同克数的面霜于手背，涂抹均匀后，将泡沫片倒在手背上，翻侧手掌两次，根据手背上粘留的泡沫片数来评价一款面霜的清爽度，泡沫片数量越少则为越清爽。</div><div style='font-family: PingFangSC-Medium;font-weight: 500;margin-top:8px;'>总结来说，最值赞扬的是CUREL珂润、SK II的面霜，都是霜状质地，但是比乳液更容易被皮肤吸收，肤感也不会粘腻但是却非常滋润，非常适合秋冬干燥的季节使用。</div>",
            //     }
            // ],
            productType:[],
            // swiperOptions: {
            //     pagination: {
            //         el: '.swiper-pagination1'
            //     },
            //     uniqueNavElements: false,
            //     slidesPerView: 4,
            //     slidesPerGroup: 3,
            //     spaceBetween: 24,
            //     // Some Swiper option/callback...
            // },
            // swiperOptions2: {
            //     pagination: {
            //         el: '.swiper-pagination2'
            //     },
            //     uniqueNavElements: false,

            //     // Some Swiper option/callback...
            // }
            swiperOption:{
                //显示分页
                pagination: {
                  el: '.swiper-pagination',
                  type : 'fraction',
                },
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                },
                //开启循环模式
                loop: false,
                spaceBetween : 20,
                slidesPerView :1,
                
            },
            swiperOption1:{
                //显示分页
                pagination: {
                  el: '.swiper-pagination1',
                  type : 'fraction',
                },
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                },
                //开启循环模式
                loop: false,
                spaceBetween : 20,
                slidesPerView :1,
                
            },
            swiperOption2:{
                //显示分页
                pagination: {
                  el: '.swiper-pagination2',
                  type : 'fraction',
                },
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                },
                //开启循环模式
                loop: false,
                spaceBetween : 20,
                slidesPerView :1,
                
            },
            list:[{},{}],
            fixbox:false,
            toolRight:40,
            reportdata:{},
            greencolors:'#60DEB4',
            yellowcolors:'#FFDB69',
            redcolors:'#FF7338',
            eeqprogresswidth:160,
            stroke_width:20,
            continentsArrary:[],  //地区数组 
            collectflag:false,
            liveTestContentTitle:[],
            sortNum:{
                '0':'一',
                '1':'二',
                '2':'三',
                '3':'四',
                '4':'五',
                '5':'六',
                '6':'七',
                '7':'八',
                '8':'九',
                '9':'十'
            },
            reportmenu:[],
            ismodalshow:false

        }
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper
        },
        totalSample(){
            return Number(this.reportdata.totalGreenProduct) + Number(this.reportdata.totalRedProduct) + Number(this.reportdata.totalYellowProduct)
        },
        atGreenPercent(){
            return Number((Number(this.reportdata.atGreenPercent) * 100).toFixed(0))
            // return this.reportdata.atGreenPercent * 100
        },
        atYellowPercent(){
            return Number((Number(this.reportdata.atYellowPercent) * 100).toFixed(0))
            // return this.reportdata.atYellowPercent * 100
        },
        atRedPercent(){
            return Number((Number(this.reportdata.atRedPercent) * 100).toFixed(0))
            // return this.reportdata.atRedPercent * 100
        },
        eeqGreenPercent(){
            return Number((Number(this.reportdata.eeqGreenPercent) * 100).toFixed(0))
            // return this.reportdata.eeqGreenPercent * 100
        },
        eeqRedPercent(){
            return Number((Number(this.reportdata.eeqRedPercent) * 100).toFixed(0))
            // return this.reportdata.eeqRedPercent * 100
        },
        continentsTotalkey(){
                var  continentsTotal = []
                if(this.reportdata.continentsTotal){
                    continentsTotal = this.continentsArrary
                    console.log(continentsTotal)
                    return continentsTotal
                }
                
        },
        keepOne(){
            return function(value,total){
                return ((value/total)*100).toFixed(0) 
            }
        },
        mulriple(){
            return Math.round(this.reportdata.productPriceHighest/this.reportdata.productPriceLowest)
        },
        sheetlength(){
            return function(item){
                // console.log('打印',item)
                if(this.reportdata.liveTestContent !=null && this.reportdata.liveTestContent[item] !=null && this.reportdata.liveTestContent[item].sheet){
                    var sheetarr = []
                    this.reportdata.liveTestContent[item].sheet.forEach((val)=>{
                        if(val.value!=null && val.value !==''){
                            sheetarr.push(val.value.split('%')[0])
                        }
                        
                    })
                    // console.log('test%%%%%%%%%%%%',sheetarr)
                    
                    return   Number(getMaxSort(sheetarr))
                }
            }
        },
        formatTimefun(){
            return function(ctime){
                if(ctime){
                    return formatTime(ctime,'Y/M/D')
                }
                
            }
        },
        creattime1(){
            if(this.reportdata.publishTime){
                return formatTime(this.reportdata.publishTime,'Y年M月D日')
            }
        },
        
    },
    mounted() {

        window.localStorage.setItem("LOCALE", this.$route.query.lang == null ? 'chs' : this.$route.query.lang);
        this.$i18n.locale = window.localStorage.getItem("LOCALE");

        var winWidth = document.documentElement.clientWidth || document.body.clientWidth;
        var rightGap = (winWidth-1200)/2;
        this.toolRight = rightGap > 0 ? rightGap*1 : 0;
      
        this.$nextTick(function () {
            window.addEventListener('scroll', this.handleScroll,true);
        });
        this.getreportdetail()
       
    },
    updated(){
        this.drawLine();
    },
    methods: {
        scrollTo(position){
            var that = this;
            var  scroll_H ;
            this.$nextTick(function(){
                if(position == 'greenrank'){
                    var d = document.getElementById("greenrank");
                    var topPos = d.offsetTop;
                    scroll_H = topPos - 110; //减去header高度
                }else{
                    scroll_H = this.$refs[position].offsetTop-110; //减去header高度
                }
                //全局方法
                that.scrollToY(scroll_H, 1500, 'easeInOutQuint');
            })
        },
        tapchoose(item) {
            if (item.type == 'rank') {
                this.getranklist()
            } else {
                this.getreportlist()
            }

        },
        handleScroll() {
            let dom =document.getElementsByClassName('content-container')[0];
            // console.log('elTop>>>>>>>>>>>',dom.scrollTop)
            let sTop = document.documentElement.scrollTop == 0 ? document.body.scrollTop : document.documentElement.scrollTop;
            // console.log('documentTop>>>',sTop);
            if(sTop > 532 || dom > 532){
                this.fixbox = true
            }else{
                this.fixbox = false;
            }
        },
        toproductdetail(item) {
            this.$router.push({
                path: '/product/'+item.productType+'/'+item.productId
            })
        },
        getreportdetail(){
            pwc_getreportdetailApi({
                reportUnionId:this.$route.params.id,
                lang:this.$route.query.lang,
                accessKey:this.$route.query.accessKey,
                timestamp:this.$route.query.timestamp,
                nonceStr:this.$route.query.nonceStr,
                sign:this.$route.query.sign,
                teststatus:this.$route.query.teststatus
            }).then(res => {
                console.log(res)
                if (res.code == 200) {
                    this.reportdata = res.data
                    if(this.reportdata.banIngListContent){
                        this.reportdata.banIngListContent = JSON.parse(this.reportdata.banIngListContent)
                    }
                    if(this.reportdata.continentsTotal){
                        this.reportdata.continentsTotal = JSON.parse(this.reportdata.continentsTotal)
                        console.log('品牌所在地比较：',this.reportdata.continentsTotal)
                        this.continentsArrary  =  Object.keys(this.reportdata.continentsTotal.content)
                    }
                    
                    if(this.reportdata.fishTips){
                        this.reportdata.fishTips = JSON.parse(this.reportdata.fishTips)
                        console.log('fishTips',this.reportdata.fishTips)
                    }
                    
                    

                    if(this.reportdata.liveTestContent!=null ){
                        this.reportdata.liveTestContent = JSON.parse(this.reportdata.liveTestContent)
                        console.log('真人测试数据：',this.reportdata.liveTestContent)

                        if(this.reportdata.liveTestContent.testStandard != null){

                            let data1 = []
                            for(let i = 0 ;i < this.reportdata.liveTestContent.testStandard.data.length ; i++){
                                
                                let item = this.reportdata.liveTestContent.testStandard.data[i];
                                let firstCol = item[0]

                                let dataItem = {}
                                dataItem.sameFirstCol = 1;
                                dataItem.data = item;
                                

                                let cacheItems = []

                                console.log('处理:'+item)

                                
                                for(let j = i ; j < this.reportdata.liveTestContent.testStandard.data.length ; j++){
                                    if(j == i){
                                        continue;
                                    }
                                    let nextItem = this.reportdata.liveTestContent.testStandard.data[j];
                                    let nextFirstCol = nextItem[0];

                                    console.log('处理next:'+nextItem)

                                    if(firstCol == nextFirstCol){
                                        dataItem.sameFirstCol++;
                                        i++;
                                        nextItem.splice(0,1)
                                        let nextDataItem = {}
                                        nextDataItem.data = nextItem
                                        nextDataItem.sameFirstCol = null;
                                        cacheItems.push(nextDataItem)

                                    }else{
                                        break;
                                    }
                                }
                                console.log(JSON.stringify(cacheItems))
                                data1.push(dataItem);
                                data1 = data1.concat(cacheItems);
                              
                            }
                            this.reportdata.liveTestContent.testStandard.data1 = data1
                            console.log(data1)
                        }



                        this.productType = Object.keys(this.reportdata.liveTestContent.resultSummary[0].livetest)


                        var temparr = [] 
                        temparr = Object.keys(this.reportdata.liveTestContent)
                        temparr.forEach((val)=>{
                            if(val !== 'testStandard' && val !== 'resultSummary'){
                                this.liveTestContentTitle.push(val)
                            }
                        })
                        // console.log('真人测试:resultSummary&&&&&&&&&',this.liveTestContentTitle)
                        
                        for(var j  in this.reportdata.liveTestContent){
                            if(j !=='resultSummary' && j !=='testStandard'){
                                // console.log('伦静妍 初始化：',j)
                                // console.log(this.reportdata.liveTestContent[j])
                                if(this.reportdata.liveTestContent[j].layout == 1){
                                    // this.current[j] = 0
                                }
                                if(this.reportdata.liveTestContent[j].layout == 2){
                                    // this.current[j] = 0
                                }
                            }
                        }
                    }


                    // 处理菜单
                    if(this.reportdata.previewVideo){
                        this.reportmenu.push({
                            title:this.$t('rankindex.report_speaker'),
                            position:'speaker'
                        })
                    }
                    if(this.reportdata.atGreen){
                        this.reportmenu.push({
                            title:this.$t('rankindex.pc_desc1'),
                            position:'safe_test_result'
                        })
                    }
                    
                    if(this.reportdata.atGreen){
                        this.reportmenu.push({
                            title:this.$t('rankindex.report_analysis'),
                            position:'data_fenxi'
                        })
                    }

                    if(this.reportdata.prdList.length > 0){
                        this.reportmenu.push({
                            title:this.$t('index.rankTitle'),
                            position:'green_ranks'
                        })
                    }

                    if(this.reportdata.liveIntruction){
                        this.reportmenu.push({
                            title:this.$t('rankindex.report_menutest'),
                            position:'real_test'
                        })
                    }
                    if(this.reportdata.fishTips){
                        this.reportmenu.push({
                            title:this.$t('rankindex.report_menutips'),
                            position:'kepu'
                        })
                    }

                    this.reportmenu.push(
                        {
                            title:this.$t('rankindex.report_standard'),
                            position:'fishqc_stander'
                        }
                    )
                    this.reportmenu.push(
                    
                        {
                            title:this.$t('rankindex.fishqcintroduction'),
                            position:'fishqc_introduction'
                        }
                    )
                    // 处理菜单结束
                    
                }else if(res.code == 403){  //未购买
                    this.ismodalshow = true
                    this.$refs.modaltoast.show({
                        type:'guide',  //弹窗类型，guide:导购页
                        itemtype:'2',    //报告
                        itemdata:res.data,
                        source:'detail'
                    });

                }else if(res.code == 401){  //未登录
                    this.ismodalshow = true
                    this.$refs.modaltoast.show({
                        type:'guide',  //弹窗类型，guide:导购页
                        itemtype:'2',    //报告
                        itemdata:res.data,
                        source:'detail'
                    });

                }else if(res.code == 415){ //不支持该语言
                    this.gorouter('/')
                }else if(res.code == 400){
                    this.$router.push({
                        path: '/Page404'
                    })
                }else {

                    this.ismodalshow = true
                    this.$refs.modaltoast.show({
                        type:'errormodal',  //弹窗类型，
                        message:res.message
                    });
                    // this.toast(res.message)

                }
            })
        },
        drawLine(){
            var _Chart  = this.$refs.myChart 
            if(_Chart){
                for(var i = 0;i<_Chart.length;i++){
                    // 基于准备好的dom，初始化echarts实例
                    let currentChart = this.$echarts.init(_Chart[i])
                    // console.log(_Chart[i])
                    var area = this.continentsArrary[i]
                    var datas = [
                        [
                            { 
                                name: this.$t('common.green_Title'), 
                                value: (this.keepOne(this.reportdata.continentsTotal.content[area].green,(this.reportdata.continentsTotal.content[area].green+this.reportdata.continentsTotal.content[area].yellow+this.reportdata.continentsTotal.content[area].red))) 
                            },
                            { 
                                name: this.$t('common.yellow_Title'), 
                                value: (this.keepOne(this.reportdata.continentsTotal.content[area].yellow,(this.reportdata.continentsTotal.content[area].green+this.reportdata.continentsTotal.content[area].yellow+this.reportdata.continentsTotal.content[area].red)))
                            },
                            { 
                                name: this.$t('common.red_Title'), 
                                value: (this.keepOne(this.reportdata.continentsTotal.content[area].red,(this.reportdata.continentsTotal.content[area].green+this.reportdata.continentsTotal.content[area].yellow+this.reportdata.continentsTotal.content[area].red)))
                            },
                        ],
                       
                    ];
                    // 绘制图表
                    currentChart.setOption({
                        title: {
                            text: this.continents[area],
                            left: 'center',
                            top:'center',
                            textStyle:{
                                color: '#424242',
                                fontSize:'18',
                                fontFamily:'PingFangSC-Medium',
                                fontWeight:'500'
                            }
                        },
                        series: datas.map(function (data, idx) {
                            var top = idx * 33.3;
                            return {
                                type: 'pie',
                                radius: ['50', '80'],
                                top: 'center',
                                left: 'center',
                                width:600,
                                avoidLabelOverlap: false,
                                itemStyle: {
                                    borderColor: '#fff',
                                    borderWidth: 1
                                },
                                color:['#60DEB4', '#FFDB69','#FF7338'],
                                label: {
                                    alignTo: 'edge',
                                    formatter: '{name|{b}}\n{time|{c} %}',
                                    minMargin: 5,
                                    edgeDistance: 10,
                                    lineHeight: 24,
                                    rich: {
                                        time: {
                                            fontSize: 12,
                                            color: '#424242'
                                        },
                                        name: {
                                            fontSize: 14,
                                            color: '#424242'
                                        },
                                    }
                                },
                                labelLine: {
                                    length: 20,
                                    length2: 60,
                                    maxSurfaceAngle:80
                                },
                                emphasis:{
                                    label:{
                                        show:true,
                                        fontSize:'30',
                                    }
                                },
                                labelLayout: function (params) {
                                    var isLeft = params.labelRect.x < currentChart.getWidth() / 2;
                                    var points = params.labelLinePoints;
                                    // Update the end point.
                                    points[2][0] = isLeft
                                        ? params.labelRect.x
                                        : params.labelRect.x + params.labelRect.width;

                                    return {
                                        labelLinePoints: points
                                    };
                                },
                                data: data
                            }
                        })
                        // title: {
                        //     text: this.continents[area],  
                        //     top: 'center',
                        //     left: 'center',
                        //     textStyle:{
                        //         color: '#424242',
                        //         fontSize:'18',
                        //         fontFamily:'PingFangSC-Medium',
                        //         fontWeight:'500'
                        //     }
                        // },
                        // series: [
                        //     {
                        //         type: 'pie',
                        //         radius: ['40%', '70%'],
                        //         avoidLabelOverlap: false,
                        //         itemStyle: {
                                    
                        //             borderRadius: 0,
                        //             borderColor: '#fff',
                        //             borderWidth: 1
                        //         },
                        //         data: [   
                        //             {
                        //                 value: this.reportdata.continentsTotal[area].green,
                        //                 name: (this.keepOne(this.reportdata.continentsTotal[area].green,(this.reportdata.continentsTotal[area].green+this.reportdata.continentsTotal[area].yellow+this.reportdata.continentsTotal[area].red))) + '%'+'品质卓越'
                        //             },
                        //             {
                        //                 value: this.reportdata.continentsTotal[area].yellow, 
                        //                 name: (this.keepOne(this.reportdata.continentsTotal[area].yellow,(this.reportdata.continentsTotal[area].green+this.reportdata.continentsTotal[area].yellow+this.reportdata.continentsTotal[area].red))) +'% 品质合格'
                        //             },
                        //             {
                        //                 value: this.reportdata.continentsTotal[area].red, 
                        //                 name: (this.keepOne(this.reportdata.continentsTotal[area].red,(this.reportdata.continentsTotal[area].green+this.reportdata.continentsTotal[area].yellow+this.reportdata.continentsTotal[area].red))) +'% 有待改善'
                        //             },
                        //         ],
                        //         color:['#60DEB4', '#FFDB69','#FF7338','blueviolet'],
                        //         label:{
                        //             fontSize:'14',
                        //             color:'#424242',
                        //             width:30,
                        //             overflow:'break',
                        //             formatter:'{name|{b}}n{time|{c}%}'
                        //         },
                        //         labelLine:{
                        //             length:6,
                        //             length2:18,
                        //             minTurnAngle:90
                        //         },
                        //     }
                        // ]
                    });

                    // 
                    

                    // option = {
                        
                    // };
                }
                
            }
            
        },
        // 收藏
        collect(){
            var  that = this
            if(that.collectflag){
                return
            }
            this.collectflag = true
            collectApi({
                id:this.$route.params.id,
                type:13
            }).then(res => {
                that.collectflag = false
                if (res.code == 200) {
                    if(that.reportdata.favor){
                        this.toast(this.$t('common.cancelcollect'))
                        that.reportdata.favor = false
                    }else {
                        that.reportdata.favor = true
                        this.toast(this.$t('common.successcollect'))
                    }
                   
                }else if(res.code == 401){
                    this.toast(this.$t('common.loginfirst'))
                }else {
                    this.toast(res.message)
                }
            })
        },
        getmaterial(e){
            console.log('回调弹窗关闭状态',e)
            this.ismodalshow = e.showstatus
        },
    }
}
</script>
